import { Phone, MessageCircle, MapPin, ShieldCheck } from "lucide-react";
import Seo from "@/components/Seo";
import { whatsappLink, telLink, mapsLink } from "@/lib/contact";

export default function MaintenancePage({ settings }) {
  const s = settings || {};
  const showWa = s.maintenance_show_whatsapp !== false;
  const showPhone = s.maintenance_show_phone !== false;
  const showDir = s.maintenance_show_directions !== false;

  return (
    <>
      <Seo title={`${s.maintenance_title || "Sitemiz Yenileniyor"} | Meguiar's İzmit`} noindex />
      <div
        data-testid="maintenance-page"
        className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-[#070707] px-6 py-16 text-center"
      >
        {/* Ambient glow */}
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute left-1/2 top-1/3 h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(247,195,0,0.10),transparent_70%)] blur-2xl" />
          <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(0,0,0,0)_0%,rgba(0,0,0,0.6)_100%)]" />
        </div>

        <div className="relative z-10 mx-auto flex w-full max-w-xl flex-col items-center">
          <img
            src="/logo.png"
            alt="Meguiar's İzmit"
            className="h-20 w-20 rounded-2xl border border-white/10 bg-black/40 object-contain p-2 shadow-[0_8px_40px_rgba(0,0,0,0.6)]"
          />

          <p className="mt-6 font-oswald text-xs uppercase tracking-[0.35em] text-gold">
            Meguiar's İzmit
          </p>

          <h1 className="mt-4 font-display text-4xl font-semibold leading-tight text-white sm:text-5xl">
            {s.maintenance_title || "Sitemiz Yenileniyor"}
          </h1>

          <p className="mt-5 max-w-lg text-base leading-relaxed text-neutral-300">
            {s.maintenance_message}
          </p>

          <div className="mt-9 flex w-full flex-col items-stretch justify-center gap-3 sm:flex-row sm:flex-wrap">
            {showWa && (
              <a
                href={whatsappLink(s)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="maintenance-whatsapp"
                className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#25D366] px-6 py-3.5 font-oswald text-sm font-bold uppercase tracking-[0.06em] text-black transition-transform hover:scale-[1.03]"
              >
                <MessageCircle className="h-5 w-5" /> WhatsApp
              </a>
            )}
            {showPhone && (
              <a
                href={telLink(s)}
                data-testid="maintenance-phone"
                className="inline-flex items-center justify-center gap-2 rounded-xl bg-gold px-6 py-3.5 font-oswald text-sm font-bold uppercase tracking-[0.06em] text-black transition-transform hover:scale-[1.03]"
              >
                <Phone className="h-5 w-5" /> Telefonla Ara
              </a>
            )}
            {showDir && (
              <a
                href={mapsLink(s)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="maintenance-directions"
                className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/20 px-6 py-3.5 font-oswald text-sm font-bold uppercase tracking-[0.06em] text-white transition-colors hover:border-gold/60 hover:text-gold"
              >
                <MapPin className="h-5 w-5" /> Yol Tarifi
              </a>
            )}
          </div>

          <div className="mt-10 flex items-center gap-2 text-sm text-neutral-400">
            <ShieldCheck className="h-4 w-4 text-gold" />
            <span>Kocaeli'nin premium araç koruma merkezi</span>
          </div>
        </div>
      </div>
    </>
  );
}
